'use client';

import { Controller } from 'react-hook-form';
import { SearchBar } from '@/shared/ui/search-bar';
import { FormFieldMessage } from './form-field-message';
import { FormFieldProps } from './types';
import { getFormFieldState } from './utils/getFormFieldState';
import { mergeRefs } from './utils/mergeRefs';
import { parseRulesForInputAttributes } from './utils/parseRulesForInputAttributes';

type Props = FormFieldProps<typeof SearchBar>;
export const FormSearchBar = ({
    name,
    control,
    defaultValue,
    disabled,
    rules,
    shouldUnregister,
    messageWrapperProps,
    isErrorVisible = true,
    isSuccessVisible,
    ref,
    ...props
}: Props) => (
    <Controller
        {...{ name, control, defaultValue, disabled, rules, shouldUnregister }}
        render={({
            field: { ref: fieldRef, ...field },
            fieldState: { error, isDirty, isTouched, invalid },
        }) => {
            const state = getFormFieldState({
                invalid,
                isDirty,
                isTouched,
                isErrorVisible,
                isSuccessVisible,
            });
            return (
                <>
                    <SearchBar
                        ref={mergeRefs([fieldRef, ref])}
                        {...parseRulesForInputAttributes(rules)}
                        {...field}
                        {...props}
                    />
                    <FormFieldMessage state={state} error={error} messageWrapperProps={messageWrapperProps} />
                </>
            );
        }}
    />
);
